const es = {
  nav: { about: "Quiénes somos", services: "Servicios", logistics: "Logística", clients: "Clientes", news: "Noticias", contact: "Contacto", cta: "Solicitar consultoría", menu: "Menú", close: "Cerrar" },
  global: {
    eyebrow: "El mundo en movimiento",
    title: "De la Costa a las _grandes capitales_.",
    intro: "Personas que hacen negocios, mercancías que viajan: ese es el mundo en el que trabajamos cada día.",
    capitals: "Grandes capitales",
    deals: "Personas & negocios",
    base: "Mi base: la Costa",
    ops: "Mercancías en movimiento",
    timezones: "Husos horarios",
    newsTicker: "Noticias del mundo · siempre actualizadas · lee más abajo en Noticias & Mercados",
  },
  news: {
    eyebrow: "06 — Noticias & Mercados",
    title: "El mundo del transporte, _en tiempo real_.",
    intro: "Titulares actualizados automáticamente desde los principales portales de logística internacional.",
    read: "Leer",
    updated: "Actualizado",
  },
  hero: {
    eyebrow: "Consultoría empresarial · Import Export · Logística",
    lines: ["Llevamos", "las empresas", "_más allá_ de la frontera."],
    sub: "Acompañamos a las empresas en la importación y exportación, los trámites documentales, la entrada en nuevos mercados y la logística internacional: del primer contacto a la entrega.",
    cta: "Hablemos de tu proyecto",
    cta2: "Ver servicios",
    scroll: "Desliza",
    tags: ["Mar", "Aire", "Tierra", "Mensajería"],
    frame: "Rutas globales, un único interlocutor",
  },
  marquee: ["Import · Export", "Trámites documentales", "Temperatura controlada", "Mercancías peligrosas DGR", "Transporte marítimo", "Carga aérea", "Transporte por carretera", "Almacenaje y embalaje", "Desarrollo de mercados"],
  about: {
    eyebrow: "01 — Quiénes somos",
    title: "Un consultor, una red, _un método_ para crecer en el exterior.",
    body1: "MF Logistics Consulting Group nace para ofrecer a las empresas un único punto de referencia cuando deciden vender, comprar o producir fuera de sus fronteras.",
    body2: "Unimos competencias documentales, conocimiento de los mercados y operativa logística para convertir una idea de expansión en un flujo real de mercancías, contratos y relaciones.",
  founderRole: "Fundadora & CEO",
  founderLine: "Una larga experiencia internacional en Europa y el mundo: acompaño a las empresas más allá de sus fronteras, con cuidado y método.",
  doorCaption: "Mi puerta está siempre abierta",
    pillars: [
      { t: "Visión de conjunto", d: "Estrategia comercial, documentos y transporte como un único proyecto." },
      { t: "Operativa real", d: "Seguimos cada envío y cada trámite hasta su cierre." },
      { t: "Red de contactos", d: "Socios, proveedores y compradores seleccionados en los mercados de destino." },
    ],
  },
  services: {
    eyebrow: "02 — Servicios",
    title: "Consultoría a medida, _del papel_ al contenedor.",
    intro: "Cada empresa es distinta: diseñamos el recorrido que mejor se adapta a la tuya.",
    items: [
      { t: "Import & Export", d: "Planificación de flujos, Incoterms, proveedores y socios logísticos para comprar y vender en el exterior con seguridad." },
      { t: "Trámites documentales", d: "Aduanas, certificados de origen, documentos de transporte y cumplimiento normativo gestionados con precisión." },
      { t: "Introducción de productos", d: "Análisis del mercado objetivo, requisitos de entrada y estrategia de lanzamiento de tus productos." },
      { t: "Desarrollo en mercados", d: "Planes de internacionalización y crecimiento comercial en nuevos países y canales." },
      { t: "Desarrollo de contactos", d: "Búsqueda y cualificación de compradores, distribuidores y socios en el mercado de interés." },
      { t: "Pedidos de mercados extranjeros", d: "Búsqueda de clientes internacionales y gestión de sus solicitudes de pedido, del primer contacto al pedido confirmado." },
      { t: "Consultoría empresarial", d: "Apoyo en organización, procesos y cualquier otra necesidad vinculada a tu actividad." },
    ],
  },
  logistics: {
    eyebrow: "03 — Logística",
    title: "Cualquier mercancía, _cualquier_ ruta.",
    intro: "Organizamos envíos completos para todo tipo de mercancía y modalidad de transporte, con almacenaje y embalaje incluidos.",
    modesTitle: "Modalidades de transporte",
    modesDesc: "Combinamos barco, avión, carretera y mensajería para equilibrar tiempos, costes y seguridad.",
    modes: ["Barco", "Avión", "Carretera", "Mensajería"],
    goodsTitle: "Tipos de mercancía",
    goods: [
      { t: "Temperatura ambiente — General cargo", d: "Carga general, grupaje y cargas completas." },
      { t: "Temperatura controlada", d: "Cadena de frío y rangos térmicos dedicados." },
      { t: "Mercancías peligrosas DGR", d: "Gestión documental y operativa ADR / IMDG / IATA." },
    ],
    subsLabel: "Subcategorías de carga",
    subs: ["Alimentos & perecederos (incluso congelados)", "Farmacéuticos", "Maquinaria & máquinas", "Bienes de lujo", "Ropa", "Cosméticos", "…y más"],
    insurance: { t: "Seguro de mercancía", d: "Protección completa de tu carga en cada tramo." },
    docsPermits: { t: "Documentos & permisos", d: "Registros, certificados sanitarios, permisos de entrada y cada trámite." },
    palletControl: { t: "Paletización & control", d: "Almacenaje, paletización y control de mercancía en almacén." },
    warehousing: { t: "Almacenaje", d: "Almacenamiento, gestión de stock y distribución." },
    packaging: { t: "Embalaje", d: "Embalajes adecuados a la mercancía, modalidad y normativa." },
    customs: { t: "Documentos y aduana", d: "Del conocimiento de embarque al certificado: todo en orden." },
  },
  newsletter: {
    eyebrow: "El boletín",
    titleAccent: "Mantente al día",
    title: " con el mundo.",
    sub: "Cada mes: rutas, mercados y consejos prácticos para vender y comprar más allá de las fronteras. Sin spam.",
    placeholder: "Tu email",
    cta: "Suscribirse",
    sending: "Enviando…",
    ok: "¡Suscripción confirmada! Recibirás nuestras noticias.",
    already: "Ya estás suscrito al boletín.",
    error: "Ha ocurrido un error. Inténtalo de nuevo.",
    privacy: "Al suscribirte aceptas recibir nuestras comunicaciones. Sin spam: puedes darte de baja cuando quieras.",
  },
  clients: {
    eyebrow: "04 — Clientes",
    title: "Empresas que eligieron _nuestros servicios_.",
    intro: "Algunas de las empresas que hemos acompañado en los mercados internacionales.",
    consTitle: "Con la _consultoría_.",
    impTitle: "Con el _import-export_.",
    placeholder: "[Logo cliente]",
    visit: "Visitar",
  },
  contact: {
    eyebrow: "05 — Contacto",
    title: "Cuéntanos _adónde_ quieres llegar.",
    intro: "Escríbenos: te contactaremos para definir juntos el mejor camino.",
    fields: { name: "Nombre y apellidos", company: "Empresa", email: "Email", phone: "Teléfono", service: "¿Qué necesitas?", message: "Mensaje" },
    servicePick: "Selecciona un servicio",
    logisticsOption: "Envíos y logística",
    submit: "Enviar solicitud",
    sending: "Enviando…",
    success: "¡Gracias! Hemos recibido tu solicitud y te contactaremos en breve.",
    error: "No se pudo enviar. Revisa los campos e inténtalo de nuevo.",
    direct: "Contacto directo",
    emailLabel: "Email",
    phoneLabel: "Teléfono",
    vatLabel: "NIF/IVA",
    addressLabel: "Oficina",
  },
  footer: { tagline: "Consultoría empresarial, import-export y logística internacional.", rights: "Todos los derechos reservados.", admin: "Área reservada", top: "Volver arriba" },
};
export default es;
